import { DiscountItemType } from "src/Modules/Discounts/types";

export type ServiceCharge = NonNullable<DiscountItemType["serviceChargeList"]>[number];

export function getTotalChargeFromAmount(serviceChargeList: ServiceCharge[], amount: number) {
  const serviceCharge = serviceChargeList?.find((sc) => amount >= sc.from && amount < sc.to);
  if (!serviceCharge) return undefined;
  if (!serviceCharge.percentage) return serviceCharge.charge + amount;
  const calculatedCharge = Math.trunc(amount * (serviceCharge.charge / 100) * 100) / 100;
  const usedCharge = calculatedCharge < serviceCharge.slap ? serviceCharge.slap : calculatedCharge;
  return amount + usedCharge;
}

export function formulateTopupOrderRequest({
  itemCode,
  amount,
  points,
  requiredFieldsInputs,
}: {
  itemCode: string;
  amount: number;
  points: number;
  requiredFieldsInputs?: Record<string, string>;
}) {
  return {
    externalTransactionId: `ext-client_${itemCode}-${crypto.randomUUID()}`,
    orderItems: [
      {
        itemCode,
        quantity: 1,
        value: amount,
        points,
        requiredFields: Object.entries(requiredFieldsInputs ?? {}).map(([key, value]) => ({ key, value })),
      },
    ],
  };
}

export const getMinMaxBounds = (serviceChargeList: ServiceCharge[]) => {
  return serviceChargeList?.reduce(
    (prev, next) => {
      return {
        from: prev.from > next.from ? next.from : prev.from,
        to: prev.to < next.to ? next.to : prev.to,
      };
    },
    {
      from: 1000000000000,
      to: 0,
    },
  );
};



/*These functions are for the total to amount conversion but they are not utilized at the moment until we resolve the issues that exist in the configuration*/

const isSlapUsed = (serviceCharge: ServiceCharge, fullAmount: number) => {
  if (!serviceCharge.percentage) return false;
  return (serviceCharge.charge * fullAmount) / (serviceCharge.charge + 100) <= serviceCharge.slap;
};

const calculateOriginalAmountForCharge = (serviceCharge: ServiceCharge, fullAmount: number) => {
  return (fullAmount * 100) / (serviceCharge.charge + 100);
};

const calculateOriginalAmountForSlap = (serviceCharge: ServiceCharge, fullAmount: number) => {
  return fullAmount - serviceCharge.slap;
};

const BOUNDARY_EPSILON = 0.01;

 function getAmountFromTotal(serviceChargeList: ServiceCharge[] | undefined, total: number) {
  const match = serviceChargeList?.find((charge) => {
    const original = isSlapUsed(charge, total)
      ? calculateOriginalAmountForSlap(charge, total)
      : calculateOriginalAmountForCharge(charge, total);
    return original >= charge.from - BOUNDARY_EPSILON && original < charge.to + BOUNDARY_EPSILON;
  });

  if (!match) return undefined;
  return isSlapUsed(match, total) ? calculateOriginalAmountForSlap(match, total) : calculateOriginalAmountForCharge(match, total);
}
